export interface AnalyticsState {
  isIdentified: boolean;
  anonymousUserId: string;
}

export const initialAnalyticsState: AnalyticsState = {
  isIdentified: false,
  anonymousUserId: "",
};
